/**
 * Legacy affiliate URL contract (courses-like routing).
 *
 * | Request path              | Served by                         | Notes |
 * | ------------------------- | --------------------------------- | ----- |
 * | `/affiliates`, `/affiliates/*` | Nuxt SSR (labs on) or affiliate index.html (labs off) | Canonical prefix |
 * | `/affiliate`, `/affiliate/*` (HTML) | Nuxt SSR → 302 to `/affiliates*` | Query + hash preserved |
 * | `/affiliate/*.(css\|js)`  | Ingress → affiliate GCS bucket    | Legacy static prefix only |
 *
 * Deep links, emails, and magic links may still use `/affiliate`. The global
 * `affiliate-path-redirect` middleware canonicalizes document paths after SSR.
 */

/**
 * Rewrites a legacy `/affiliate` path to its `/affiliates` equivalent.
 * Returns `null` when the path is already canonical or unrelated.
 */
export function getCanonicalAffiliatePath(path: string): string | null {
  if (path === '/affiliate') {
    return '/affiliates'
  }

  if (path.startsWith('/affiliate/')) {
    return `/affiliates${path.slice('/affiliate'.length)}`
  }

  return null
}

/**
 * Convenience predicate for middleware that only needs to detect legacy paths.
 */
export function isLegacyAffiliatePath(path: string): boolean {
  return getCanonicalAffiliatePath(path) !== null
}
